import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  token: localStorage.getItem('finai-token') || null,
  loading: Boolean(localStorage.getItem('finai-token')), // true if token exists, needs initial user fetch
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem('finai-token', action.payload);
      } else {
        localStorage.removeItem('finai-token');
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearAuth: (state) => {
      state.user = null;
      state.token = null;
      state.loading = false;
      localStorage.removeItem('finai-token');
    },
  },
});

export const { setUser, setToken, setLoading, clearAuth } = authSlice.actions;
export default authSlice.reducer;
